import React from "react";
import Accordion from "components/Accordion";
import { Content, ContentText } from "components/DependentsContent";

export default function ListNumbers({ ...props }) {
  if (!props.items) return null;
  let page = props.page ? props.page : 1;
  let itemsPerPage = props.itemsPerPage ? props.itemsPerPage : 5;

  return (
    <>
      {props.items
        .slice((page - 1) * itemsPerPage, page * itemsPerPage)
        .map((c, index) => (
          <Accordion
            text={<ContentText {...c} />}
            status={c.associated?.status}
            eligible={c.eligible}
            initialState={c.eligible}
            content={
              <Content
                {...c}
                next={props.next}
                setCustomData={props.setCustomData}
                customData={props.customData}
                tabIndex={index + 40 + 2}
              />
            }
            key={index + 1 * page * itemsPerPage}
            tabIndex={index + 40 + 1}
            index={index}
          />
        ))}
      <br />
    </>
  );
}
